import { derived, writable } from 'svelte/store';

export interface SavedService {
  id: string;
  productCode: string;
  categoryCode: string;
  description: string;
  imageUrls: string[];
  isExisting?: boolean;
  entryNumber?: string;
  isSaved?: boolean;
  isModified?: boolean;
}

export const openHomeMaintenancePopup = writable(false);

export const selectedServiceIds = writable<string[]>([]);

export const serviceData = writable<Record<string, SavedService>>({});
export const currentHomeMaintenanceServiceData = writable<Record<string, unknown>>({});

export const hasSelectedServices = derived(serviceData, d => Object.keys(d).length > 0);

export const homeMaintenanceAtcOpen = writable(false);
export const homeMaintenanceAtcData = writable(null);
export const cityUnavailable = derived(currentHomeMaintenanceServiceData, $data => $data?.cityUnavailable === true);

export const showCityUnavailableError = writable(false);

export const hasValidServices = derived(serviceData, $serviceData => {
  const entries = Object.values($serviceData);

  if (!entries.length) return false;

  //If any checked service is not saved → disable ATC
  const hasUnsaved = entries.some(service => service.isSaved !== true);

  if (hasUnsaved) return false;

  // At least one valid saved + modified service
  return entries.some(service => service.isSaved === true && service.isModified === true);
});

export function openHomeMaintenanceAtcDialog(data) {
  homeMaintenanceAtcData.set(data);
  homeMaintenanceAtcOpen.set(true);
  closeHomeMaintenanceDialog();
  resetHomeMaintenanceState();
}

export function closeHomeMaintenanceAtcDialog() {
  homeMaintenanceAtcOpen.set(false);
}
export const closeHomeMaintenanceDialog = () => {
  openHomeMaintenancePopup.set(false);
};

export function resetHomeMaintenanceState() {
  selectedServiceIds.set([]);
  serviceData.set({});
}
